import { ciEquals } from './ciEquas'

/**
 * Case insensitive comparison if both have value
 */
export const ciEqualsAndHasValue = (a: unknown, b: unknown) => {
  if (a || b || a === 0 || b === 0) {
    return ciEquals(a, b)
  }

  return false
}
